import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogImage?: string;
  type?: 'website' | 'article' | 'profile';
  schema?: Record<string, unknown> | Record<string, unknown>[];
  robots?: string;
  keywords?: string;
  breadcrumbs?: { name: string; url: string }[];
}

function resolveSiteUrl(siteUrl: string, pathOrUrl?: string): string {
  if (!pathOrUrl) return siteUrl;
  if (pathOrUrl.startsWith('http')) return pathOrUrl;
  const separator = pathOrUrl.startsWith('/') ? '' : '/';
  return `${siteUrl}${separator}${pathOrUrl}`;
}

export const SEOHead = ({
  title,
  description,
  canonicalUrl,
  ogImage = '/og/home.png',
  type = 'website',
  schema,
  robots,
  keywords,
}: SEOHeadProps) => {
  const siteUrl = 'https://www.rooflyzer.pro';
  const fullCanonical = resolveSiteUrl(siteUrl, canonicalUrl);
  const fullImage = resolveSiteUrl(siteUrl, ogImage);

  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{title} | Rooflyzer OS</title>
      <meta name="description" content={description} />
      {robots && <meta name="robots" content={robots} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Schema.org Structured Data */}
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
};
